export const renderComponent = (name, reports) => {
  return reports.includes(name)
}
